/// <reference path="types.d.ts" />

import { SCALE_MODES } from '@pixi/constants';

export const Constant = {
    maxTextures: 16,
    bufferSize: 2048,
    boundSize: 1024,
    boundCountPerBuffer: 1,
    use32bitIndex: false,
    SCALE_MODE: SCALE_MODES.LINEAR,
    DO_CLEAR: true
};